/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useDeleteApplicationMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText, removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteApplication({ onSuccess }: Props) {
  const [deleteApplicationMutation, { client, ...rest }] =
    useDeleteApplicationMutation({
      onCompleted: (data) => {
        if (data.deleteApplication) {
          onSuccess();
          showSuccess(generateActionSuccessText("Application")()("deleted")());
        } else {
          showError();
        }
      },
    });

  async function deleteApplication(id: string) {
    await deleteApplicationMutation({
      variables: {
        input: {
          id,
        },
      },
    });

    removeFromApolloCache(client.cache, `Application:${id}`, "applications");
  }

  return [deleteApplication, { client, ...rest }] as const;
}
